<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать рекламное место</strong>
                </CCardHeader>
                <CCardBody>
                    <AdsPlaceUpsertForm @success="$router.push(`/ads-places`)" />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import AdsPlaceUpsertForm from '@/components/ads-places/AdsPlaceUpsertForm';

    export default {
        name: 'AdsPlaceCreate',

        components: {
            AdsPlaceUpsertForm,
        },
    };
</script>
